import { render } from "./Equipments.vue?vue&type=template&id=6213f0c9"
import script from "./Equipments.vue?vue&type=script&lang=js"
export * from "./Equipments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__